/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceModel } from '../models/DeviceModel';
import type { DeviceModelDto } from '../models/DeviceModelDto';
import type { PagedModelEntityModelDeviceModelDto } from '../models/PagedModelEntityModelDeviceModelDto';
import type { PagedResourcesAssemblerDeviceModelDto } from '../models/PagedResourcesAssemblerDeviceModelDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceCatalogControllerService {
    /**
     * @returns PagedModelEntityModelDeviceModelDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 2147483647,
        sort,
        filter,
    }: {
        assembler: PagedResourcesAssemblerDeviceModelDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
        filter?: string,
    }): CancelablePromise<PagedModelEntityModelDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/deviceCatalog',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'filter': filter,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns DeviceModel OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: DeviceModelDto,
    }): CancelablePromise<DeviceModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/deviceCatalog',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns DeviceModel OK
     * @throws ApiError
     */
    public static delete({
        id,
    }: {
        id: string,
    }): CancelablePromise<DeviceModel> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/deviceCatalog/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns DeviceModelDto OK
     * @throws ApiError
     */
    public static update({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: DeviceModelDto,
    }): CancelablePromise<DeviceModelDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/deviceCatalog/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
